import { all } from 'redux-saga/effects';
import edit from 'sagas/user/edit';
import list from 'sagas/user/list';

export default function* user() {
  yield all([list(), edit()]);
}
